/**
 * Image Registry
 * Maps string keys used in form JSON configs to imported image assets.
 * This allows JSON configs to reference images by key while Vite handles
 * the actual imports, hashing, and bundling.
 *
 * Usage in JSON: { "image": "detached" }
 * Resolved at render time via: imageRegistry["detached"]
 */

import bungalow from '../assets/images/bungalow.png'
import flat from '../assets/images/apartment.png'
import detached from '../assets/images/detached.png'
import semiDetached from '../assets/images/semi-detached.png'
import terraced from '../assets/images/terraced.png'
import pitchedTile from '../assets/images/pitched_tile.png'
import pitchedSlate from '../assets/images/pitched_slate.png'
import flatRoof from '../assets/images/flat_roof.png'
import metalRoof from '../assets/images/metal_roof.png'


const imageRegistry: Record<string, string> = {
  bungalow,
  detached,
  flat,
  'semi-detached': semiDetached,
  terraced,
  pitchedTile,
  pitchedSlate,
  'flat-roof': flatRoof,
  'metal-roof': metalRoof,
}

export default imageRegistry
